import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../../shared/api/client';
import { invalidatedBy, queryKeys } from '../../shared/api/queryKeys';

/** Каталог ролей (`GET /admin/roles`): роли — данные бэкенда (AD-A6), клиент их не знает. */
export function useRoles() {
  return useQuery({
    queryKey: queryKeys.roles.all(),
    queryFn: () => api.get('/admin/roles'),
    staleTime: 5 * 60_000,
  });
}

/**
 * Выдача и отзыв роли (CAP-4). После успеха инвалидируются `users` **и** `audit` — журнал
 * обязан показать запись без ручного обновления (AD-A5, `invalidatedBy.roleChange`).
 */
export function useRoleChange(userId: string) {
  const queryClient = useQueryClient();
  const settle = () =>
    Promise.all(
      invalidatedBy.roleChange.map((queryKey) => queryClient.invalidateQueries({ queryKey })),
    );

  const grant = useMutation({
    mutationFn: (roleSlug: string) =>
      api.post('/admin/users/{userId}/roles', { params: { path: { userId } }, body: { roleSlug } }),
    onSuccess: settle,
  });
  const revoke = useMutation({
    mutationFn: (roleSlug: string) =>
      api.delete('/admin/users/{userId}/roles/{roleSlug}', {
        params: { path: { userId, roleSlug } },
      }),
    onSuccess: settle,
  });
  return { grant, revoke };
}
